<template>
  <div>
    <va-modal
      class="modal"
      v-model="showFichePartenaire"
      cancelClass="none"
      :okText="saveMessage"
      cancelText="Annuler"
      max-width="100%"
      v-on:ok="savePartenaire"
      v-on:cancel="closeModal"
      noEscDismiss
      :noOutsideDismiss="isModified"
    >
      <div class="forcewidth">
        <div class="row">
          <div class="flex md3">
            <h5 :style="{ color: this.$themes.primary }">
              {{ partenaire.nom }}
            </h5>
          </div>

          <div class="flex md9">
            <div class="row row-inside">
              <div class="flex md3" v-show="isactive"></div>
              <div class="flex md1">
                <va-button
                  class="custom-button"
                  small
                  :disabled="!partenaire.email"
                  @click="openCourriel(partenaire)"
                  >Courriel</va-button
                >
              </div>
              <div class="flex md3 pl-4">
                <div class="row row-inside">
                  <div class="flex md6">
                    <va-badge
                      class="fullwidth"
                      :color="verificationStatuts.color"
                      >{{ verificationStatuts.text }}</va-badge
                    >
                  </div>
                  <div class="flex md6">
                    <va-checkbox
                      label="Vérifier"
                      v-model="verifierPartenaire"
                    />
                  </div>
                  <div class="flex md12">
                    <p class="text--secondary small-text">
                      {{ verificationStatuts.msg }}
                    </p>
                  </div>
                </div>
              </div>

              <div class="flex md2">
                <va-toggle small v-model="isactive" label="En activité" />
              </div>

              <div class="flex md3" v-show="!isactive">
                <va-date-picker
                  class="warning-date px-2"
                  :config="{ dateFormat: 'd-m-Y' }"
                  label="Date de fin d'activité"
                  v-model="fin_activite"
                  removable
                  :error="!isactive && !fin_activite"
                />
              </div>
              <div class="flex md3">
                <va-date-picker
                  class="px-2"
                  :config="{ dateFormat: 'd-m-Y' }"
                  label="Date de début d'activité"
                  v-model="debut_activite"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="flex md6">
            <va-tabs v-model="tabsState">
              <va-tab>Fiche partenaire</va-tab>
            </va-tabs>
            <va-separator />
          </div>
        </div>
        <div class="row">
          <div class="flex md8">
            <div class="row">
              <div class="flex md6">
                <va-input
                  v-model="partenaire.nom"
                  placeholder="Nom partenaire"
                  label="Nom"
                  :error="pValidNom"
                />
              </div>
              <div class="flex md4 px-1">
                <va-button
                  class="fullwidth"
                  small
                  disabled
                  outline
                  :color="colorJournal"
                  @click="openJournal"
                  >journal{{
                    dateFinJournal ? " jusqu’au " + dateFinJournal : ""
                  }}</va-button
                >
              </div>
              <div class="flex md2 px-1">
                <va-toggle
                  small
                  v-model="partenaire.annonceur"
                  label="Annonceur"
                />
              </div>
            </div>
            <div class="row">
              <div class="flex md4">
                <va-input
                  v-model="partenaire.email"
                  placeholder="Courriel"
                  label="Courriel"
                />
              </div>
              <div class="flex md2 px-2">
                <va-input
                  v-model="phoneNumberPartenaire"
                  placeholder="Telephone"
                  label="Telephone"
                  v-on:paste="trimOnPaste('telephonePartenaire')"
                  v-on:focus="
                    phoneNumberPartenaire = removeWhiteSpace(
                      phoneNumberPartenaire
                    )
                  "
                  v-on:blur="
                    phoneNumberPartenaire = formatPhoneNumber(
                      phoneNumberPartenaire
                    )
                  "
                  :error="!isValidPhoneNumber(phoneNumberPartenaire)"
                />
              </div>
              <div class="flex md2 pr-2">
                <va-input
                  v-model="portableNumberPartenaire"
                  placeholder="Portable"
                  label="Portable"
                  v-on:paste="trimOnPaste('portablePartenaire')"
                  v-on:focus="
                    portableNumberPartenaire = removeWhiteSpace(
                      portableNumberPartenaire
                    )
                  "
                  v-on:blur="
                    portableNumberPartenaire = formatPhoneNumber(
                      portableNumberPartenaire
                    )
                  "
                  :error="!isValidPhoneNumber(portableNumberPartenaire)"
                />
              </div>
              <div class="flex md4">
                <va-input
                  v-model="partenaire.site_internet"
                  placeholder="Site internet"
                  label="Site internet"
                />
              </div>
            </div>
            <div class="row">
              <div class="flex md12 my-1">
                <h6>Contact principal</h6>
              </div>
            </div>
            <div class="row">
              <div class="flex md2">
                <va-select
                  label="Civilité"
                  v-model="contact.titre"
                  :options="titreOptions"
                  no-clear
                />
              </div>
              <div class="flex md3 px-2">
                <va-input
                  v-model="contact.nom"
                  placeholder="Contact inconnu"
                  label="Nom"
                  :error="cValidNom"
                />
              </div>
              <div class="flex md3">
                <va-input
                  :disabled="contact.titre === 'SOCIÉTÉ'"
                  v-model="contact.prenom"
                  placeholder="-"
                  label="Prénom"
                />
              </div>
              <div class="flex md4 pl-2">
                <va-input
                  v-model="contact.titre_honorifique"
                  placeholder="Titre"
                  label="Titre"
                />
              </div>
            </div>
            <div class="row" v-if="contact.titre === 'SOCIÉTÉ'">
              <div class="flex md2">
                <va-select
                  label="Civilité contact"
                  v-model="contact.titre_societe"
                  :options="titreOptionsSociete"
                  no-clear
                />
              </div>
              <div class="flex md3 px-2">
                <va-input
                  v-model="contact.nom_societe"
                  placeholder="Contact inconnu"
                  label="Nom contact"
                />
              </div>
              <div class="flex md3">
                <va-input
                  v-model="contact.prenom_societe"
                  placeholder="-"
                  label="Prénom contact"
                />
              </div>
            </div>
            <div class="row">
              <div class="flex md4">
                <va-input
                  v-model="contact.email"
                  placeholder="Courriel"
                  label="Courriel"
                />
              </div>
              <div class="flex md2 px-2">
                <va-input
                  v-model="phoneNumberContact"
                  placeholder="Telephone"
                  label="Telephone"
                  v-on:paste="trimOnPaste('telephoneContact')"
                  v-on:focus="
                    phoneNumberContact = removeWhiteSpace(phoneNumberContact)
                  "
                  v-on:blur="
                    phoneNumberContact = formatPhoneNumber(phoneNumberContact)
                  "
                  :error="!isValidPhoneNumber(phoneNumberContact)"
                />
              </div>
              <div class="flex md2 pr-2">
                <va-input
                  v-model="portableNumberContact"
                  placeholder="Portable"
                  label="Portable"
                  v-on:paste="trimOnPaste('portableContact')"
                  v-on:focus="
                    portableNumberContact = removeWhiteSpace(
                      portableNumberContact
                    )
                  "
                  v-on:blur="
                    portableNumberContact = formatPhoneNumber(
                      portableNumberContact
                    )
                  "
                  :error="!isValidPhoneNumber(portableNumberContact)"
                />
              </div>
              <div class="flex md3 pl-4">
                <va-checkbox label="Adresse identique" v-model="sameAdresse" />
              </div>
            </div>
          </div>
          <div class="flex md4 px-4">
            <div class="flex md12">
              <va-tabs grow v-model="tabsStateAdresses">
                <va-tab>Adresse principale</va-tab>
                <va-tab v-if="!sameAdresse">Adresse contact</va-tab>
              </va-tabs>
              <va-separator />
            </div>
            <div v-show="tabsStateAdresses === 0" class="row">
              <div class="flex md12">
                <va-input
                  v-model="adresse_partenaire.adresse"
                  placeholder="Adresse inconnue"
                  label="Adresse"
                />
              </div>
              <div class="flex md12">
                <va-input
                  v-model="adresse_partenaire.complement"
                  placeholder="Complement d'adresse"
                  label="Adresse suite"
                />
              </div>
              <div class="flex md3">
                <va-input
                  v-model="adresse_partenaire.code_postal"
                  placeholder="Code Postal"
                  label="Code Postal"
                  :error="pValidCP"
                />
              </div>
              <div class="flex md6 px-2">
                <va-input
                  v-model="adresse_partenaire.ville"
                  placeholder="Ville"
                  label="Ville"
                  :error="pValidVille"
                />
              </div>
              <div class="flex md3">
                <va-input
                  v-model="adresse_partenaire.cedex"
                  placeholder="Cedex"
                  label="Cedex"
                />
              </div>
            </div>
            <div v-show="tabsStateAdresses === 1" class="row">
              <div class="flex md12">
                <va-input
                  v-model="adresse_contact.adresse"
                  placeholder="Adresse inconnue"
                  label="Adresse"
                />
              </div>
              <div class="flex md12">
                <va-input
                  v-model="adresse_contact.complement"
                  placeholder="Complement d'adresse"
                  label="Adresse suite"
                />
              </div>
              <div class="flex md3">
                <va-input
                  v-model="adresse_contact.code_postal"
                  placeholder="Code Postal"
                  label="Code Postal"
                  :error="cValidCP"
                />
              </div>
              <div class="flex md6 px-2">
                <va-input
                  v-model="adresse_contact.ville"
                  placeholder="Ville"
                  label="Ville"
                  :error="cValidVille"
                />
              </div>
              <div class="flex md3">
                <va-input
                  v-model="adresse_contact.cedex"
                  placeholder="Cedex"
                  label="Cedex"
                />
              </div>
            </div>
          </div>
        </div>
        <dashboard-contact-list
          v-show="partenaire.idpartenaire"
          :partenaire="partenaire"
          :adresse_partenaire="adresse_partenaire"
          v-on:updateContact="updateContact()"
        />
        <div class="row">
          <div class="flex md6 pa-3">
            <dashboard-comments-partenaires
              class="relance-container-list"
              ref="relancemng"
              :idpartenaire="idpartenaire"
              setheight="15"
            ></dashboard-comments-partenaires>
          </div>
        </div>
      </div>
    </va-modal>
    <va-modal
      class="modal"
      v-model="showJournal"
      cancelClass="none"
      okText="Fermer"
      cancelText="Annuler"
      max-width="100%"
      v-on:ok="saveJournal"
      v-on:cancel="closeJournal"
      title="Abonnement Journal"
    >
      <div class="row">
        <div class="flex md12">
          <va-date-picker
            class="warning-date px-2"
            :config="{ dateFormat: 'd-m-Y' }"
            label="Date de fin d’adbonnement"
            v-model="dateFinJournal"
          />
        </div>
        <div class="flex md12">
          <va-button
            class="fullwidth"
            small
            color="danger"
            @click="dateFinJournal = null"
            >Supprimer l’abonnement</va-button
          >
        </div>
      </div>
    </va-modal>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { cloneDeep, isEqual, find } from "lodash";
import { isPhoneNumber, removeWhiteSpace } from "../../services/utils";
import DashboardContactList from "./DashboardContactList";
import DashboardCommentsPartenaires from "./DashboardCommentsPartenaires";

export default {
  name: "fichePartenaire",
  props: ["value", "idpartenaire"],
  components: {
    DashboardContactList,
    DashboardCommentsPartenaires,
  },
  data() {
    return {
      dateFinJournalSave: null,
      dateFinJournal: null,
      dateFinJournalO: null,
      showJournal: false,
      sameAdresse: true,
      titreOptionsSociete: ["MONSIEUR", "MADAME"],
      titreOptions: ["MONSIEUR", "MADAME", "SOCIÉTÉ"],
      isAnnonceur: false,
      verifierPartenaire: false,
      tabsState: 0,
      tabsStateAdresses: 0,
      showFichePartenaire: false,
      phoneNumberPartenaire: null,
      portableNumberPartenaire: null,
      phoneNumberContact: null,
      portableNumberContact: null,
      //suffix O for original used to compare the inputs
      phoneNumberPartenaireO: null,
      portableNumberPartenaireO: null,
      phoneNumberContactO: null,
      portableNumberContactO: null,
      verificationStatuts: {
        text: "Jamais vérifié",
        color: "danger",
        msg: "",
      },
      isactive: true,
      isactiveO: true,
      fin_activite: null,
      debut_activite: null,
      fin_activiteO: null,
      debut_activiteO: null,
      partenaireO: null,
      journal: { color: "dark", text: "" },
      partenaire: {
        nom: null,
        annonceur: false,
        site_internet: null,
        telephone: null,
        portable: null,
        email: null,
      },
      contactO: null,
      contact: {
        titre: null,
        nom: null,
        prenom: null,
        telephone: null,
        email: null,
        portable: null,
        note: null,
        fonction: null,
        isactif: null,
        nom_societe: null,
        prenom_societe: null,
        titre_societe: null,
        titre_honorifique: null,
      },
      adresse_partenaireO: null,
      adresse_partenaire: {
        code_postal: null,
        ville: null,
        adresse: null,
        complement: null,
        cedex: null,
      },
      adresse_contactO: null,
      adresse_contact: {
        code_postal: null,
        ville: null,
        adresse: null,
        complement: null,
        cedex: null,
      },
    };
  },
  mounted() {
    this.resetValues();
    if (this.value) {
      this.loadPartenaire(this.idpartenaire);
    }
    this.showFichePartenaire = this.value; // initialize internal variables
  },

  methods: {
    async updateContact() {
      await this.loadPartenaire(this.idpartenaire, "contact");
      this.$emit("updateContacts");
    },
    openJournal() {
      this.showJournal = true;
      this.dateFinJournalSave = this.dateFinJournal;
    },
    saveJournal() {},
    closeJournal() {
      this.dateFinJournal = this.dateFinJournalSave;
    },
    isValidPhoneNumber(str) {
      if (!str) {
        return true;
      }
      return isPhoneNumber(removeWhiteSpace(str));
    },
    resetValues() {
      this.dateFinJournal = null;
      this.journal = { color: "dark", text: "" };
      this.verifierPartenaire = false;
      this.tabsState = 0;
      this.tabsStateAdresses = 0;
      this.sameAdresse = true;
      this.sameAdresseO = true;
      this.phoneNumberPartenaire = null;
      this.portableNumberPartenaire = null;
      this.phoneNumberContact = null;
      this.portableNumberContact = null;
      this.verificationStatuts = {
        text: "Jamais vérifié",
        color: "danger",
        msg: "",
      };
      this.isactive = true;
      this.debut_activite = null;
      this.fin_activite = null;
      this.partenaire = {
        nom: null,
        annonceur: false,
        site_internet: null,
        telephone: null,
        portable: null,
        email: null,
      };
      this.contact = {
        titre: null,
        nom: null,
        prenom: null,
        telephone: null,
        email: null,
        portable: null,
        note: null,
        fonction: null,
        isactif: null,
        nom_societe: null,
        prenom_societe: null,
        titre_societe: null,
        titre_honorifique: null,
      };
      this.adresse_partenaire = {
        code_postal: null,
        ville: null,
        adresse: null,
        complement: null,
        cedex: null,
      };
      this.adresse_contact = {
        code_postal: null,
        ville: null,
        adresse: null,
        complement: null,
        cedex: null,
      };
    },
    closeModal() {
      this.resetValues();
      this.$emit("input", false);
    },
    async savePartenaire() {
      this.showFichePartenaire = true;

      if (!this.isModified) {
        this.closeModal();
        return;
      }
      if (!this.isComplete) {
        this.launchEpicmaxToast("Information incomplètes");
      } else {
        // validate all informations that need to be sent
        // partenaire:
        let partenaire = this.partenaire;
        if (!partenaire.nom) {
          this.launchEpicmaxToast("Le nom du partenaire doit être renseigné");
          return;
        }

        if (this.isValidPhoneNumber(this.phoneNumberPartenaire)) {
          partenaire.telephone = this.phoneNumberPartenaire;
        } else if (this.phoneNumberPartenaire) {
          this.launchEpicmaxToast("Numéro de téléphone invalide");
          return;
        }

        if (this.isValidPhoneNumber(this.portableNumberPartenaire)) {
          partenaire.portable = this.portableNumberPartenaire;
        } else if (this.portableNumberPartenaire) {
          this.launchEpicmaxToast("Numéro de téléphone invalide");
          return;
        }
        partenaire.isactive = true;
        if (!this.isactive) {
          if (!this.fin_activite) {
            this.launchEpicmaxToast("Date de fin d’activitée non renseignée");
            return;
          }
          let tmpDate = moment(this.fin_activite, "DD-MM-YYYY");
          if (tmpDate.isValid()) {
            partenaire.isactive = false;
            partenaire.fin_activite = tmpDate.format("YYYY-MM-DD");
          } else {
            this.launchEpicmaxToast("Date de fin d’activité invalide");
          }
        }
        if (partenaire.isactive) {
          partenaire.fin_activite = null;
        }

        if (this.debut_activite) {
          let tmpDateDeb = moment(this.debut_activite, "DD-MM-YYYY");
          if (tmpDateDeb.isValid()) {
            partenaire.debut_activite = tmpDateDeb.format("YYYY-MM-DD");
          } else {
            this.launchEpicmaxToast("Date de début d’activité invalide");
          }
        }

        //contact principal
        let contact = this.contact;
        if (!contact.nom) {
          this.launchEpicmaxToast("Le nom du contact doit être renseigné");
          return;
        }

        if (this.contact.titre === "SOCIÉTÉ") {
          this.contact.prenom = null;
        }

        if (this.isValidPhoneNumber(this.phoneNumberContact)) {
          contact.telephone = this.phoneNumberContact;
        } else if (this.phoneNumberContact) {
          this.launchEpicmaxToast("Numéro de téléphone invalide");
          return;
        }

        if (this.isValidPhoneNumber(this.portableNumberContact)) {
          contact.portable = this.portableNumberContact;
        } else if (this.portableNumberContact) {
          this.launchEpicmaxToast("Numéro de téléphone invalide");
          return;
        }

        //adresse principale
        let adresse_partenaire = this.adresse_partenaire;
        if (!adresse_partenaire.code_postal || !adresse_partenaire.ville) {
          this.launchEpicmaxToast("Adresse incomplète");
        }

        //adresse contact
        let adresse_contact = this.adresse_contact;
        if (
          !this.sameAdresse &&
          (!adresse_contact.code_postal || !adresse_contact.ville)
        ) {
          this.launchEpicmaxToast("Adresse du contact incomplète");
        }
        contact.haveAdresse = !this.sameAdresse;

        //send for creation

        let params = {
          partenaire: partenaire,
          contact: contact,
          adresse_partenaire: adresse_partenaire,
          adresse_contact: adresse_contact,
          verification: this.verifierPartenaire,
          dateFinJournal: this.dateFinJournal
            ? moment(this.dateFinJournal, "DD-MM-YYYY").format("YYYY-MM-DD")
            : null,
        };

        //TODO update partenaires if changes
        let res = await axios.post("/api/partenaire/save", params);

        let idpartenaire = res.data.idpartenaire;

        //open fiche partenaire for the newly created entity
        this.$emit("update", idpartenaire);
        this.closeModal();
      }
    },

    async loadPartenaire(idpartenaire, limit) {
      try {
        let res = await axios.get("/api/partenaire", {
          params: {
            idpartenaire: idpartenaire,
          },
        });

        if (limit !== "contact") {
          this.partenaire = res.data.partenaire;
          this.isactive = true;
          if (
            this.partenaire.fin_activite &&
            moment(this.partenaire.fin_activite, "YYYY-MM-DD").isValid()
          ) {
            this.isactive = false;
            this.fin_activite = moment(
              this.partenaire.fin_activite,
              "YYYY-MM-DD"
            ).format("DD-MM-YYYY");
          }
          if (
            this.partenaire.debut_activite &&
            moment(this.partenaire.debut_activite, "YYYY-MM-DD").isValid()
          ) {
            this.debut_activite = moment(
              this.partenaire.debut_activite,
              "YYYY-MM-DD"
            ).format("DD-MM-YYYY");
          }

          this.phoneNumberPartenaire = this.partenaire.telephone
            ? this.formatPhoneNumber(this.partenaire.telephone)
            : null;
          this.portableNumberPartenaire = this.partenaire.portable
            ? this.formatPhoneNumber(this.partenaire.portable)
            : null;

          this.adresse_partenaire = res.data.adresse_partenaire;

          if (res.data.verification) {
            let dateVerification = moment(res.data.verification.date_verif);

            this.verificationStatuts.msg =
              moment(dateVerification).format("DD-MM-YYYY") +
              " " +
              res.data.verification.utilisateur.prenom +
              " " +
              res.data.verification.utilisateur.nom;

            if (
              moment(dateVerification).isAfter(moment().subtract(1, "years"))
            ) {
              // entreprise vérifiée dans l'année
              this.verificationStatuts.text = "Vérifié";
              this.verificationStatuts.color = "success";
            } else {
              this.verificationStatuts.text = "A vérifier";
              this.verificationStatuts.color = "warning";
            }
          } else {
            this.verificationStatuts.text = "Jamais vérifié";
            this.verificationStatuts.color = "danger";
            this.verificationStatuts.msg = "";
          }

          if (res.data.journal) {
            let dateFinJournal = moment(
              res.data.journal.date_fin,
              "YYYY-MM-DD"
            );
            if (moment(dateFinJournal).isAfter(moment())) {
              this.dateFinJournal = moment(dateFinJournal).format("DD-MM-YYYY");
              this.journal = {
                color: "success",
                text: "jusqu’au " + moment(dateFinJournal).format("DD-MM-YYYY"),
              };
            }
          } else {
            this.journal = { color: "dark", text: "" };
          }

          this.partenaireO = cloneDeep(this.partenaire);
          this.adresse_partenaireO = cloneDeep(this.adresse_partenaire);
          this.dateFinJournalO = this.dateFinJournal;
          this.phoneNumberPartenaireO = this.phoneNumberPartenaire;
          this.portableNumberPartenaireO = this.portableNumberPartenaire;
          this.fin_activiteO = this.fin_activite;
          this.debut_activiteO = this.debut_activite;
          this.verifierPartenaireO = this.verifierPartenaire;
          this.isactiveO = this.isactive;
        }

        this.contact = res.data.contact;
        if (this.contact.idadresse) {
          this.sameAdresse = false;
          this.adresse_contact = res.data.adresse_contact;
        } else {
          this.sameAdresse = true;
          this.adresse_contact = {
            code_postal: null,
            ville: null,
            adresse: null,
            complement: null,
            cedex: null,
          };
        }

        this.phoneNumberContact = this.contact.telephone
          ? this.formatPhoneNumber(this.contact.telephone)
          : null;
        this.portableNumberContact = this.contact.portable
          ? this.formatPhoneNumber(this.contact.portable)
          : null;

        this.contactO = cloneDeep(this.contact);
        this.adresse_contactO = cloneDeep(this.adresse_contact);
        this.phoneNumberContactO = this.phoneNumberContact;
        this.portableNumberContactO = this.portableNumberContact;
        this.sameAdresseO = this.sameAdresse;
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors du chargement de la fiche");
        this.closeModal();
      }
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
    openCourriel(entreprise) {
      let email = partenaire.email;
      window.location.href = "mailto:" + email;
    },
    trimOnPaste(entry) {
      if (entry == "telephonePartenaire") {
        setTimeout(() => {
          this.phoneNumberPartenaire = this.removeWhiteSpace(
            this.phoneNumberPartenaire
          );
        }, 200);
      }
      if (entry == "portablePartenaire") {
        setTimeout(() => {
          this.portableNumberPartenaire = this.removeWhiteSpace(
            this.portableNumberPartenaire
          );
        }, 200);
      }
      if (entry == "telephoneContact") {
        setTimeout(() => {
          this.phoneNumberContact = this.removeWhiteSpace(
            this.phoneNumberContact
          );
        }, 200);
      }
      if (entry == "portableContact") {
        setTimeout(() => {
          this.portableNumberContact = this.removeWhiteSpace(
            this.portableNumberContact
          );
        }, 200);
      }
    },
    removeWhiteSpace(str) {
      return removeWhiteSpace(str);
    },
    isNormalInteger(str) {
      var n = Math.floor(Number(str));
      return n !== Infinity && (String(n) === str || n === str) && n >= 0;
    },
    formatPhoneNumber(str) {
      if (isPhoneNumber(str)) {
        let newStr =
          str.slice(0, 2) +
          " " +
          str.slice(2, 4) +
          " " +
          str.slice(4, 6) +
          " " +
          str.slice(6, 8) +
          " " +
          str.slice(8, 10);
        return newStr;
      }
      return str;
    },
  },
  computed: {
    colorJournal: function () {
      if (
        this.dateFinJournal &&
        moment(this.dateFinJournal, "DD-MM-YYYY").isAfter(moment())
      ) {
        return "success";
      } else {
        return "dark";
      }
    },
    isPartenaireModified: function () {
      if (!isEqual(this.partenaire, this.partenaireO)) {
        return true;
      } else {
        return false;
      }
    },
    isContactModified: function () {
      if (
        !isEqual(this.contact, this.contactO) ||
        this.sameAdresseO !== this.sameAdresse
      ) {
        return true;
      } else {
        return false;
      }
    },
    isAdressePmodified: function () {
      if (!isEqual(this.adresse_partenaire, this.adresse_partenaireO)) {
        return true;
      } else {
        return false;
      }
    },
    isAdresseCmodified: function () {
      if (!isEqual(this.adresse_contact, this.adresse_contactO)) {
        return true;
      } else {
        return false;
      }
    },
    isNumbersModified: function () {
      if (
        this.phoneNumberPartenaire !== this.phoneNumberPartenaireO ||
        this.portableNumberPartenaire !== this.portableNumberPartenaireO ||
        this.phoneNumberContact !== this.phoneNumberContactO ||
        this.portableNumberContactO !== this.portableNumberContact ||
        this.verifierPartenaire !== this.verifierPartenaireO ||
        this.dateFinJournal !== this.dateFinJournalO ||
        this.debut_activite !== this.debut_activiteO ||
        this.fin_activite !== this.fin_activiteO ||
        this.isactive !== this.isactiveO
      ) {
        return true;
      } else {
        return false;
      }
    },
    isModified: function () {
      let modified =
        this.isPartenaireModified ||
        this.isContactModified ||
        this.isAdressePmodified ||
        this.isAdresseCmodified ||
        this.isNumbersModified;
      return modified;
    },
    isComplete: function () {
      let bool =
        !this.pValidNom &&
        !this.cValidNom &&
        !this.pValidCP &&
        !this.pValidVille;
      if (!this.sameAdresse) {
        bool = bool & !this.cValidCP && !this.cValidVille;
      }
      return bool;
    },
    saveMessage: function () {
      return this.isModified
        ? "Sauvegarder les modifications"
        : "Fermer la fiche";
    },
    pValidNom: function () {
      if (this.partenaire.nom && this.partenaire.nom.length < 200) {
        return false;
      }
      return true;
    },
    cValidNom: function () {
      if (this.contact.nom && this.contact.nom.length < 200) {
        return false;
      }
      return true;
    },
    pValidCP: function () {
      if (this.adresse_partenaire.code_postal) {
        return false;
      }
      return true;
    },
    pValidVille: function () {
      if (this.adresse_partenaire.ville) {
        return false;
      }
      return true;
    },
    cValidVille: function () {
      if (this.adresse_contact.ville) {
        return false;
      }
      return true;
    },
    cValidCP: function () {
      if (this.adresse_contact.code_postal) {
        return false;
      }
      return true;
    },
  },
  watch: {
    sameAdresse(newvalue) {
      if (newvalue) {
        this.tabsStateAdresses = 0;
      }
    },

    value() {
      // Parent property changed; update internal variables
      this.showFichePartenaire = this.value;
      if (!this.value) {
        this.resetValues();
      } else if (!this.idpartenaire) {
        this.resetValues();
        this.closeModal();
      } else {
        this.loadPartenaire(this.idpartenaire);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.forcewidth {
  width: 85vw;
  height: 75vh;
  overflow: auto;
}
.fullwidth {
  width: 95%;
}

.custom-button {
  width: 90%;
  border-color: #40e583;
  border-width: 2px;
  border-style: solid;
  position: relative;
  top: -0.3em;
}
</style>
